export enum HouseKeepingCheckinOptionsModel {
  YES = "yes",
  NO = "no",
  ALERT = "alert",
}
